import * as React from 'react';

import Tooltip from 'components/Tooltip';

type Props = {
  heading?: string,
  children: React.ReactNode,
  tooltipMessage?: string
};

class ListsStatsCardItem extends React.PureComponent<Props> {
  renderHeading(): React.ReactNode {
    const { heading, tooltipMessage } = this.props;

    return (
      <div className="lists-stats-card-item__heading">
        <div className="lists-stats-card-item__heading-value">
          {heading}
        </div>
        {
          tooltipMessage && (
            <div className="lists-stats-card-item__heading-tooltip">
              <Tooltip
                message={tooltipMessage}
                showQuestionMark
              />
            </div>
          )
        }
      </div>
    );
  }

  renderData(): React.ReactNode {
    const { children } = this.props;

    return (
      <div className="lists-stats-card-item__data">
        {children}
      </div>
    );
  }

  render(): React.ReactNode {
    const { heading } = this.props;

    return (
      <div className="lists-stats-card-item">
        {
          heading &&
            this.renderHeading()
        }
        {this.renderData()}
      </div>
    );
  }
}

export default ListsStatsCardItem;
